export const minHeightOptions: Record<string, string> = {
  sm: '360px',
  md: '480px',
  lg: '600px',
  xl: '720px',
}
